module.exports = __webpack_public_path__ + "img/smile-logo.a5f4f7cb.svg";